import { useIntl } from 'react-intl';
import { Translation } from 'src/types';

const TranslatedName = ({ translations }: { translations: Translation[] }) => {
    const { locale } = useIntl();

    const localeTranslation = translations.find((translation) => translation.language === locale);
    if (!localeTranslation) return '-';
    return (
        <div className="flex flex-col gap-0 whitespace-nowrap">
            <span className="font-medium">{localeTranslation.name}</span>
            {Object.hasOwn(localeTranslation, 'description') && (
                <span className="-mt-px whitespace-nowrap text-gray-500">{localeTranslation.description ?? '-'}</span>
            )}
        </div>
    );
};

export default TranslatedName;
